let Content = require('./content');
let Header = require('./header');
let Collapse = require('../collapse');

module.exports = {
    constructor: Collapse,
    children: [
        {
            name: 'content',
            component: Content,
            parentPropsMap: {
                isSmallTree: 'isSmallTree'
            },
            watcher: {
                isDisabled: ['order', 'isDisabled'],
                basicColumns: ['order', 'computed', 'exportColumns', 'basic', 'viewOrder'],
                optionalColumns: ['order', 'computed', 'exportColumns', 'optional', 'viewOrder'],
                isOfflineOrder: ['order', 'computed', 'isOfflineOrder']
            }
        },
        {
            name: 'header',
            component: Header
        }
    ]
};



// WEBPACK FOOTER //
// ./components/common/custom-order/additional-parameters/index.js